import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

const QrCodeIcon = (props: any) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M3 3h8v8H3V3zm2 2v4h4V5H5zm8-2h8v8h-8V3zm2 2v4h4V5h-4zM3 13h8v8H3v-8zm2 2v4h4v-4H5zm10 0h2v2h-2v-2zm0 4h6v2h-6v-2zm4-4h2v6h-2v-6z" />
  </SvgIcon>
);

export default QrCodeIcon;
